import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Bar from '../../assets/images/chart-bar.svg';
import HorizontalBar from '../../assets/images/chart-horizontal-bar.svg';
import Line from '../../assets/images/chart-line.svg';
import Pie from '../../assets/images/chart-pie.svg';
import Table from '../../assets/images/chart-table.svg';

const ChartsMenu = ({ active, list, onClick }) => (
  <div className="tvt-charts-menu">
    {list.map((item, index) => {
      const className = classNames('tvt-charts-menu-item', {
        active: item.id === active,
        disabled: item.disabled
      });
      return (
        <>
          {index !== 0 ? <span>|</span> : ''}
          <button
            key={item.id}
            className={className}
            onClick={item.disabled ? () => null : onClick(item.id)}
          >
            {item.id === 'charts-table' && (
              <img
                className="img-tvt-charts-menu-item"
                src={Table}
                alt="table"
              />
            )}
            {item.id === 'charts-column' && (
              <img
                className="img-tvt-charts-menu-item"
                src={Bar}
                alt="chart-bar"
              />
            )}
            {item.id === 'charts-bar' && (
              <img
                className="img-tvt-charts-menu-item"
                src={HorizontalBar}
                alt="chart-bar"
              />
            )}
            {item.id === 'charts-line' && (
              <img
                className="img-tvt-charts-menu-item"
                src={Line}
                alt="chart-line"
              />
            )}
            {item.id === 'charts-pie' && (
              <img
                className="img-tvt-charts-menu-item"
                src={Pie}
                alt="chart-pie"
              />
            )}
          </button>
        </>
      );
    })}
  </div>
);

ChartsMenu.propTypes = {
  active: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      className: PropTypes.string.isRequired
    })
  ),
  onClick: PropTypes.func
};

ChartsMenu.defaultProps = {
  list: [],
  onClick: () => {}
};

export default ChartsMenu;
